import { render, staticRenderFns } from "./pegasusaktarim.vue?vue&type=template&id=00bf6ca1&"
import script from "./pegasusaktarim.vue?vue&type=script&lang=js&"
export * from "./pegasusaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports